import { DesktopCapturerSourceExt } from '../../UserContext'

const imageContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    height: '80%',
    border: 'solid 1px #666',
    borderRadius: 10,
    transition: 'border-color 75ms',
    padding: 2, // subtract 1 in imageContainerSelected to compensate for border width changing
}

const imageContainerSelectedStyle = {
    border: 'solid 2px #f9cc04',
    transition: 'border-color 75ms',
    padding: 1,

    '&:hover': {
        borderColor: '#f9cc04',
    },
}

export function DesktopSourcesListItem({
    source,
    isSelected,
    onSelect,
}: {
    source: DesktopCapturerSourceExt | { name: string }
    isSelected: boolean
    onSelect: () => void
}) {
    // @ts-ignore
    const imgDataUrl = source?.thumbnail?.toDataURL ? source.thumbnail.toDataURL() : null

    return (
        <div className="flex flex-col w-[260px] h-[200px] m-1 p-1 cursor-pointer" onClick={onSelect}>
            <div
                style={{
                    ...imageContainerStyle,
                    ...(isSelected ? imageContainerSelectedStyle : {}),
                }}
            >
                {imgDataUrl && <img src={imgDataUrl} className="object-contain w-full h-full" alt={source.name} />}
            </div>

            <div className="flex justify-left items-center flex-grow mt-1 ml-1">
                <div className="text-ellipsis whitespace-nowrap overflow-hidden" title={source.name}>
                    {source.name}
                </div>
            </div>
        </div>
    )
}
